import { RouteConfig } from 'src/routing/types'

const ROUTE: RouteConfig = {
  name: 'membership-product',
  path: () => '/unlimited-membership',
}

export default ROUTE
